import { reactive } from "vue";

export const useModel = () => {
  return {};
};

export type Model = ReturnType<typeof useModel>;
